var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgP1000(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 254,
    viewBox: "0 0 25 254",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.5822 192.737H9.49289C9.22503 192.737 9.01074 192.483 9.01074 192.166L9.01074 184.737H15.0107V192.166C15.0107 192.483 14.7965 192.737 14.5822 192.737Z",
    fill: "#99B2C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.01074 122.737H12.0107V167.737H8.01074C8.01074 167.737 7.43931 138.937 4.01074 122.737Z",
    fill: "#E5ECF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0107 122.737H12.0107V167.737H16.0107C16.0107 167.737 16.5822 138.937 20.0107 122.737Z",
    fill: "#E5ECF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.01074 127.737C8.01074 125.528 9.8016 123.737 12.0107 123.737C14.2199 123.737 16.0107 125.528 16.0107 127.737V186.737C16.0107 187.842 15.1153 188.737 14.0107 188.737H10.0107C8.90617 188.737 8.01074 187.842 8.01074 186.737V127.737Z",
    fill: "#E5ECF0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.0107 106.737H2.01074L2.01074 122.737C2.01074 123.842 6.48789 124.737 12.0107 124.737C17.5336 124.737 22.0107 123.842 22.0107 122.737L22.0107 106.737Z",
    fill: "#CCD8E1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.0076 109.691L24.0076 27.7368C24.0076 26.3294 23.2534 25.6436 22.0193 25.0404L17.6313 22.8958L12.0777 20.282L5.90711 23.2309L2.06761 25.0404C0.764929 25.6436 0.0107422 26.85 0.0107422 28.2574L0.0107422 109.737C0.0107422 110.841 5.38332 111.737 12.0107 111.737C18.6382 111.737 24.0107 110.841 24.0107 109.737C24.0107 109.721 24.0097 109.706 24.0076 109.691Z",
    fill: "#F5F7F9"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 20,
    width: 25,
    height: 92
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.0076 109.691L24.0076 27.7368C24.0076 26.3294 23.2534 25.6436 22.0193 25.0404L17.6313 22.8958L12.0777 20.282L5.90711 23.2309L2.06761 25.0404C0.764929 25.6436 0.0107422 26.85 0.0107422 28.2574L0.0107422 109.737C0.0107422 110.841 5.38332 111.737 12.0107 111.737C18.6382 111.737 24.0107 110.841 24.0107 109.737C24.0107 109.721 24.0097 109.706 24.0076 109.691Z",
    fill: "#F5F7F9"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.0107422,
    y: 24.7368,
    width: 6,
    height: 87,
    fill: "#E5ECF0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18.0107,
    y: 24.7368,
    width: 6,
    height: 87,
    fill: "#E5ECF0"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M12.0773 20.6848C14.6522 20.6848 16.7395 19.8746 16.7395 18.8752C16.7395 17.8758 14.6522 17.0657 12.0773 17.0657C9.5024 17.0657 7.41504 17.8758 7.41504 18.8752C7.41504 19.8746 9.5024 20.6848 12.0773 20.6848Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8525 21.7563C19.4813 19.6117 17.3558 18.0032 14.9561 17.333C14.4762 17.6681 13.3792 17.8692 12.008 17.8692C10.7053 17.8692 9.67684 17.6681 9.12834 17.4C6.72865 18.1373 4.53466 19.6117 3.16341 21.8234C2.68347 22.6276 2.47778 23.6329 2.47778 24.5712L2.47778 33.753C2.47778 34.4902 3.16341 35.0264 3.91759 34.9593C6.18015 34.5572 8.85409 34.2891 11.8023 34.2891C14.9561 34.2891 17.6986 34.5572 20.0983 34.9593C20.8525 35.0934 21.5381 34.5572 21.5381 33.753L21.5381 24.4372C21.5381 23.4989 21.3324 22.5606 20.8525 21.7563Z",
    fill: "#54BCE3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.44214 23.2981C4.40201 22.0247 5.77326 21.0864 7.21307 20.3492C7.96726 20.0141 8.72144 19.746 9.54419 19.5449C10.3669 19.3439 11.1897 19.2769 12.0124 19.2769C13.6579 19.2769 15.372 19.612 16.8118 20.3492C18.3202 21.0194 19.6229 22.0247 20.5827 23.2981C19.2115 22.4268 17.8402 21.7566 16.4004 21.2875C15.6462 21.0864 14.9606 20.8853 14.2064 20.7513C13.4523 20.6173 12.6981 20.5502 11.9439 20.5502C10.4355 20.5502 8.92713 20.8183 7.48732 21.2204C6.18464 21.7566 4.74482 22.4268 3.44214 23.2981Z",
    fill: "#3295BA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0107 55.7368H8.01074L8.01074 83.6483H16.0107L16.0107 55.7368Z",
    fill: "#54BCE3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3386 61.3699H9.78027L9.78027 77.5956H14.3386L14.3386 61.3699Z",
    fill: "#FBF9DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3386 61.3699H9.78027V61.7061H14.3386V61.3699Z",
    fill: "#A49448"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3386 77.3433H9.78027V77.6796H14.3386V77.3433Z",
    fill: "#A49448"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3386 72.0466H9.78027V72.3829H14.3386V72.0466Z",
    fill: "#A49448"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3386 66.666H9.78027V67.0023H14.3386V66.666Z",
    fill: "#A49448"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.129 62.9751C12.4313 62.9751 12.6713 63.0588 12.8491 63.2261C13.0284 63.392 13.118 63.6136 13.118 63.891C13.118 64.1024 13.0511 64.3314 12.9175 64.578C12.7853 64.8245 12.5521 65.1511 12.2179 65.5577H13.3094V66.0905H11.2471V66.0267C11.4871 65.7405 11.693 65.4836 11.8646 65.2561C12.0378 65.0271 12.1715 64.8378 12.2657 64.688C12.3599 64.5369 12.4267 64.4084 12.4662 64.3027C12.5057 64.1971 12.5255 64.0877 12.5255 63.9747C12.5255 63.8338 12.4784 63.7156 12.3842 63.6202C12.2915 63.5233 12.1784 63.4749 12.0447 63.4749C11.8046 63.4749 11.5555 63.607 11.2972 63.8712V63.2679C11.5691 63.0727 11.8464 62.9751 12.129 62.9751Z",
    fill: "#DB0300"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2931 68.2437C12.6151 68.2437 12.8704 68.3838 13.0587 68.6642C13.2486 68.9445 13.3436 69.3276 13.3436 69.8135C13.3436 70.3037 13.2502 70.6905 13.0633 70.9738C12.8764 71.2571 12.6212 71.3987 12.2976 71.3987C11.9695 71.3987 11.7097 71.2585 11.5183 70.9782C11.3283 70.6964 11.2334 70.3111 11.2334 69.8223C11.2334 69.335 11.3283 68.9504 11.5183 68.6686C11.7082 68.3853 11.9664 68.2437 12.2931 68.2437ZM11.8259 69.8399C11.8259 70.543 11.9816 70.8945 12.2931 70.8945C12.5969 70.8945 12.7488 70.5246 12.7488 69.7849C12.7488 69.0935 12.5954 68.7478 12.2885 68.7478C11.9801 68.7478 11.8259 69.1119 11.8259 69.8399Z",
    fill: "#101620"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2989 73.4827C12.621 73.4827 12.8762 73.6228 13.0646 73.9032C13.2545 74.1835 13.3495 74.5666 13.3495 75.0525C13.3495 75.5427 13.256 75.9295 13.0692 76.2128C12.8823 76.4961 12.6271 76.6377 12.3035 76.6377C11.9753 76.6377 11.7155 76.4976 11.5241 76.2172C11.3342 75.9354 11.2393 75.5501 11.2393 75.0613C11.2393 74.574 11.3342 74.1894 11.5241 73.9076C11.714 73.6243 11.9723 73.4827 12.2989 73.4827ZM11.8318 75.0789C11.8318 75.782 11.9875 76.1335 12.2989 76.1335C12.6028 76.1335 12.7547 75.7636 12.7547 75.0239C12.7547 74.3325 12.6012 73.9869 12.2944 73.9869C11.986 73.9869 11.8318 74.3509 11.8318 75.0789Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.4718 24.7723V33.753C21.4718 34.4903 20.8547 35.0264 20.032 34.8924C19.2778 34.7583 18.455 34.6913 17.5637 34.5573L17.5637 23.1638C18.6607 23.5659 19.2778 23.901 20.2377 24.3032C20.9918 24.5042 20.9918 24.5042 21.4718 24.7723Z",
    fill: "#3295BA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.54785 24.7743L2.54785 33.755C2.54785 34.4922 3.16491 35.0284 3.98766 34.8943C4.74185 34.7603 5.5646 34.6933 6.45591 34.5592L6.45591 23.1658C5.35891 23.5679 4.74185 23.903 3.78197 24.3051C3.02779 24.5062 3.02779 24.5062 2.54785 24.7743Z",
    fill: "#3295BA"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: -2.98926,
    y: -0.936035,
    width: 30.2949,
    height: 259,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 253,
    fill: "white",
    transform: "translate(0.305664 0.0639648)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgP1000);
export default __webpack_public_path__ + "static/media/P1000.f47f041a0526bf55f2ca926dc1574245.svg";
export { ForwardRef as ReactComponent };